import React from 'react'
import TablaVistaCcUo from '../components/VistaCcUo/TablaVistaCcUo';
import '../components/VistaCcUo/EstilosVistaCcUo.css';

const VistaCentroCosto_UOrg = () => {
  return (
    <div className="container_vistaCentroCostoUO">
        <TablaVistaCcUo />
    </div>
  )
}

export default VistaCentroCosto_UOrg